import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import classNames from 'classnames';
const DEFAULT_INTERVAL_MS = 400;
const DOT_STATES = ['.', '..', '...'];
export default function TextDotsAnimation({ intervalMs = DEFAULT_INTERVAL_MS, className }) {
    const [index, setIndex] = useState(0);
    useEffect(() => {
        const id = setInterval(() => {
            setIndex((prev) => (prev + 1) % DOT_STATES.length);
        }, intervalMs);
        return () => clearInterval(id);
    }, [intervalMs]);
    return (_jsx("span", { className: classNames('inline-block', className), "aria-hidden": "true", children: DOT_STATES[index] }));
}
